(function waitForJQuery() {
  if (typeof window.jQuery === 'undefined') {
    window.setTimeout(waitForJQuery, 50);
    return;
  }

  jQuery(document).ready(function($) {
    $("#search_input").keyup(function() {
      var search_val = $('#search_input').val();
      var len = $(".search_article a:contains(" + search_val + ")").length;
      $('.search_article a').hide();
      $('.search_error').hide();
      if (search_val != '') {
        if (len >= 1) {
          $('.search_article').show();
          $(".search_article a:contains(" + search_val + ")").show();
          $('.search_error').hide();
        } else {
          $('.search_error').html("result not found for " + search_val).show();
          $('.search_article').hide();
        }
      }
    });

    if ($(window).width() < 767) {
      $('.itg_collections').addClass('productgrid-listview');
      $('.itg_collections').removeClass('productgrid-gridview');
      $('.utils-viewtoggle-button[data-collection-view="list-view"]').addClass('active');
      $('.utils-viewtoggle-button[data-collection-view="grid-view"]').removeClass('active');
    }

  });
})();
